import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import {Trans} from "@lingui/macro";

interface ConfirmModalProps{
    confirmCallback: () => void
    cancelConfirmCallback: () => void
    text: string
    textId: string
}


export class ConfirmModal extends React.Component<ConfirmModalProps, {}> {

    render(){
        return(
            <Dialog
                open={true}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>
                    <Trans id="cm-title">Conferma</Trans>
                </DialogTitle>
                    <DialogContent>
                        <Typography>
                            <Trans id={this.props.textId}>{this.props.text}</Trans>
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button size="small" onClick={this.props.cancelConfirmCallback}>
                            <Trans id={"cm-close-btn"}>
                                Annulla
                            </Trans>
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            type="button"
                            onClick={this.props.confirmCallback}>
                            <Trans id={"cm-confirm-btn"}>
                                Conferma
                            </Trans>
                        </Button>
                    </DialogActions>
            </Dialog>


        )}
}